// File: frontend/src/components/marketing/partners/partnersMotion.js
//
// Motion helpers for the public /ambassador page. GSAP is reached ONLY through
// utils/gsapCore.js. The section reveal now lives in ../landingMotion.js,
// shared with "/", and is re-exported here so this page's imports stay put.
//
// ── PROGRESSIVE ENHANCEMENT IS THE CONTRACT ─────────────────────────────────
//
// The markup and CSS always render FINISHED content: fully opaque, in place,
// readable with JavaScript off, GSAP failing, or reduced motion on. Nothing in
// any stylesheet on this page starts at opacity 0 or off-screen.
//
// Motion is layered on afterwards, and only when all of these hold:
//
//   1. GSAP initialised and this is not a reduced-motion visitor;
//   2. the element is BELOW the fold at that moment (so hiding it cannot flash
//      anything the reader is looking at);
//   3. ScrollTrigger accepted the batch. If it throws, the elements are put
//      straight back to their finished state.
//
// Only then is the section marked data-motion="ready" and the pending elements
// set to a start state. They reveal as their top edge reaches the bottom 6% of
// the viewport, so nothing can sit hidden inside the visible area.
//
// Opacity, never visibility. An element held at opacity 0 is still focusable
// and still read by a screen reader; a focusin listener reveals it the moment
// keyboard focus lands on it. autoAlpha (visibility:hidden) would make tabbing
// silently skip content that has not been scrolled to yet.
//
// An earlier version of this page hid content with gsap.from() on mount and
// relied on each trigger firing later. When the tier and milestone sections
// arrived with the API data they pushed every trigger below them out of place,
// and whole sections stayed invisible. The rules above are the fix.

export { useReveal } from "../landingMotion";

/** Extra media queries this page uses, alongside gsapCore's MQ. */
export const PAGE_MQ = {
  finePointer: "(hover: hover) and (pointer: fine)",
};
